import { render, staticRenderFns } from "./RbvInputCoordinates.vue?vue&type=template&id=9ea44fcc&"
import script from "./RbvInputCoordinates.vue?vue&type=script&lang=js&"
export * from "./RbvInputCoordinates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports